import { __awaiter } from "tslib";
import { BaseService } from "../../base";
export class TeiLogService extends BaseService() {
    static get entity() {
        return "tei_log";
    }
    static get responseName() {
        return "tei_log";
    }
    static getByInterconsultId(interconsult_id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "get",
                path: `find_by_interconsult_id/${interconsult_id}`,
            });
        });
    }
}
